<template>
  <!--  <div-->
  <!--    id="account-aria-live"-->
  <!--    aria-live="assertive"-->
  <!--  ></div>-->
  <vue-element-loading
    :active="isLoading"
    :is-full-screen="true"
    spinner="line-wave"
    color="#f4a912"
    size="128"
  />
<!--    <Header v-if="isLoggedIn" />-->
  <Navigation v-if="isLoggedIn && !$route.meta.hideNavbar" />
  <Message />
  <div :class="{ 'with-navbar': !$route.meta.hideNavbar }">
    <router-view />
  </div>
  <ScrollToTop />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '@/store/app.store';
import { useAuthStore } from '@/store/auth.store';
import VueElementLoading from 'vue-element-loading';
import Navigation from '@/components/Navigation.vue';
import Message from '@/components/Message.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';
import Header from '@/components/Header.vue';
// import SearchBar from './components/SearchBar.vue';
// import 'mapbox-gl/dist/mapbox-gl.css';

const isLoggedIn = computed(() => {
  const authStore = useAuthStore();
  return authStore.isLoggedIn;
});

const isLoading = computed(() => {
  const appStore = useAppStore();
  return appStore.isLoading;
});
</script>
<style>
body {
  margin: 0;
  /* Adjust this to match your navbar height */
  background-color: #f9f9f9;
  text-decoration: none !important;
}

.with-navbar {
  //padding-top: 100px;
}
a{
  text-decoration: none !important;
}
</style>
